<template>
  <div class="box">
    <div class="h_title">
      <div>曝光台</div>
      <div class="more">｜查风险，就上中能曝光台</div>
    </div>
    <div class="input">
      <div class="input_c" @click="toMore">
        <div class="text">可输入姓名、手机号、身份证号等进行查询</div>
        <el-button type="primary" icon="el-icon-search">查询</el-button>
      </div>
    </div>
    <div class="title_2">可查询到以下几种情况</div>
    <div class="box_box">
      <div class="box_center">
        <div class="item">
          <img src="@/assets/image/exposure/icon_1.webp" alt="" srcset="" />
          <div>违约事实</div>
        </div>
        <div class="item">
          <img src="@/assets/image/exposure/icon_2.webp" alt="" srcset="" />
          <div>高风险人员</div>
        </div>
        <div class="item">
          <img src="@/assets/image/exposure/icon_3.webp" alt="" srcset="" />
          <div>其他</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import dayjs from "dayjs";
import userinfo from "@/mixins/userinfo";
export default {
  name: "banner-carousel",
  mixins: [userinfo],
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    async toMore() {
      await this.verifyUserAuth();
      await this.verifyCompanyAuth();
      this.$router.push({
        name: "exposure",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '../homeStyle.scss' as *;

.box {
  width: 100%;
  height: 251px;
  border-radius: $border-radius;
  background-image: url(~@/assets/image/baoguangtai_bg.webp);
  background-size: 100% 154px;
  background-repeat: no-repeat;
  background-color: #fff;
  .more {
    font-size: 14px;

    font-weight: normal;
    cursor: pointer;
  }
  .h_title {
    justify-content: flex-start;
    color: #0d2374;
    height: 56px;
  }
  .input {
    height: 44px;
    margin-top: 10px;
    padding: 0 16px;
    &_c {
      height: 44px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.5);
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left:  12px;
      padding-right: 4px;
      cursor: pointer;

      .text {
        font-size: 14px;
        color: #999999;
      }
    }
  }
  .title_2 {
    height: 44px;
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: 350;
    line-height: normal;
    color: #999999;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
  .box_box {
    height: 80px;
    padding: 0 16px;
    .box_center {
      width: 100%;
      height: 81px;
      border-radius: 4px;
      opacity: 1;

      /* 自动布局 */
      display: flex;
      background: rgba(250, 250, 250, 0.6);
      background-image: url(~@/assets/image/baoguangtai_bg2.webp);
      background-size: 100% 100%;
      align-items: center;
      justify-content: space-around;
      .item {
        font-size: 12px;
        font-weight: 500;
        color: #0062ff;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>
